import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { Switch } from "src/base-components/Switch";
import {
  CommonSchemaEditRowProps,
  SchemaUI,
} from "src/schema/schemaMappingUtils";

export const SchemaRequiredSwitch: React.FC<CommonSchemaEditRowProps> = ({
  rowName,
  disabled,
}) => {
  const { control } = useFormContext<SchemaUI>();
  return (
    <Controller
      control={control}
      name={`${rowName}.required`}
      render={(props) => (
        <Switch
          dataLoc="schema-field-required"
          disabled={disabled}
          enabled={!!props.field.value}
          onChange={() => {
            props.field.onChange(!props.field.value);
          }}
        />
      )}
    />
  );
};
